if (!customElements.get('product-bar')) {
  class ProductBar extends HTMLElement {
    constructor() {
      super();

      this.debouncedScroll = debounce(
        () => this.toggleVisibility(),
        300
      );
    }

    setHandlers() {
      window.addEventListener(
        'scroll',
        this.debouncedScroll.bind(this)
      );
      window.addEventListener(
        'resize',
        this.debouncedScroll.bind(this)
      );
    }

    toggleVisibility() {
      const formActions = document.querySelector(
        '[data-product-actions]'
      );
      const footer = document.querySelector('.footer');

      const shouldShowBar =
        formActions.getBoundingClientRect().top <= 0 && footer.getBoundingClientRect().top - window.innerHeight >= 0;

      this.classList.toggle('is-hidden', !shouldShowBar);
    }

    connectedCallback() {
      this.setHandlers();
      this.toggleVisibility();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.debouncedScroll);
      window.removeEventListener('resize', this.debouncedScroll);
    }
  }

  customElements.define('product-bar', ProductBar);
}
